import { Message } from 'dg-web-shared/lib/Localized';
import { VehicleLicensePlateType } from 'dg-web-shared/common/models/Vehicle';
import { ZoneType } from 'dg-web-shared/dto/ZoneType.ts';
import { ParkingaboProductType } from 'product-shared/product-template/ParkingaboProductType.ts';

export interface ParkingaboProductListItem {
    contractExternalId: string;
    name: Message;
    remark: string;
    info: Message | null;
    zones: ParkingaboZoneInfo[];
    validFrom: string;
    validTo: string | null;
    priceRappen: number;
    type: ParkingaboProductType;
    state: ParkingaboProductState;
    vehicleTypes: VehicleLicensePlateType[];
    hasBooking: boolean;
    token: string;
}

export interface ParkingaboZoneInfo {
    zoneId: number;
    name: string;
    city: string;
    zipCode: string;
    zoneType: ZoneType;
    extZoneCode: number | null;
}

export interface ParkingaboCityInfo {
    zipCode: string;
    city: string;
}

export function productTypeHasPrice(type: ParkingaboProductType): boolean {
    switch (type) {
        case ParkingaboProductType.RESERVATION:
        case ParkingaboProductType.GUEST_RESERVATION_UBS:
        case ParkingaboProductType.SUBSCRIPTION:
            return true;
        case ParkingaboProductType.ALL_ACCESS:
        case ParkingaboProductType.GUEST_PERMIT_VALID_TO:
        case ParkingaboProductType.GUEST_RESERVATION:
        case ParkingaboProductType.PERMIT_UNTIL_REVOCATION:
        case ParkingaboProductType.PERMIT_FREE_FIXED_DURATION:
        case ParkingaboProductType.PERMIT_FREE_VALID_TO:
        case ParkingaboProductType.GUEST_DAY_PASS:
            return false;
    }
}

export const enum ParkingaboProductState {
    EXPIRED = 'EXPIRED',
    ACTIVE = 'ACTIVE',
    FUTURE = 'FUTURE',
}
